import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NotificationAlert from "react-notification-alert";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import Axios from 'axios';
import { API_CONFIG } from "./../config/config.jsx";
import Typography from '@material-ui/core/Typography';


const styles = theme => ({
  container: {
    padding: theme.spacing(2),
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // Full viewport height
  },
  textField: {
    width: "100%", // Adjust text field to span the full width of its container
  },
  formHeader: {
    marginBottom: theme.spacing(3),
    textAlign: "center",
    color: "#3f51b5",
  },
  buttonContainer: {
    marginTop: theme.spacing(4),
    textAlign: "center",
  },
  submitButton: {
    backgroundColor: "#3f51b5",
    color: "white",
    '&:hover': {
      backgroundColor: "#303f9f",
    },
    padding: theme.spacing(1.5, 4), // Larger button for better aesthetics
    fontSize: "1.2rem", // Slightly bigger font size
  },
  card: {
    backgroundColor: "white",
    boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    width: "100%", // Full width of the container
    maxWidth: "800px", // Larger maximum width for the card
    padding: theme.spacing(4), // More padding for a spacious look
  },
});



class CableStoreOnboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prename : '',
      name: '',
      mobileNo: '',
      address: '',
      deviceId: localStorage.getItem('deviceId'),
      email: '',
      vehicleNumber: '',
      payoutBankDetails: '',
      password: '',
      repeatPassword: '',
      email : '',
      repeatEmail : ''
    };
    this.autocompleteInput = React.createRef();
    this.autocomplete = null;
  }

  // componentDidMount() {
  //   const mobileNo = sessionStorage.getItem('plugoUserMobileNo');
  // }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit = event => {
    event.preventDefault();

    if (this.state.password !== this.state.repeatPassword) {
      const options = {
        place: 'tc',
        message: "Passwords do not match. Please check and try again.",
        type: 'danger',
        icon: 'fas fa-exclamation-triangle',
        autoDismiss: 4
      };
      if (this.notification && this.notification.state.notifyTR.length < 1) {
        this.notification.notificationAlert(options);
      }
      return; // Prevent form submission
    }
    if (this.state.email !== this.state.repeatEmail) {
      const options = {
        place: 'tc',
        message: "Email do not match. Please check and try again.",
        type: 'danger',
        icon: 'fas fa-exclamation-triangle',
        autoDismiss: 4
      };
      if (this.notification && this.notification.state.notifyTR.length < 1) {
        this.notification.notificationAlert(options);
      }
      return; // Prevent form submission
    }
    const mobileNo = sessionStorage.getItem('plugoUserMobileNo');
    const userId = sessionStorage.getItem("plugoUserId");
    this.setState({
      isButtonDisabled: true
    });
    const createStoreData = {
      deviceId: this.state.deviceId,
      mobile: this.state.mobileNo,
      name: this.state.prename + " " + this.state.name,
      address: this.state.address,
      vehicleNumber: this.state.vehicleNumber,
      email: this.state.email,
      password: this.state.password
    };
    const token = sessionStorage.getItem('plugoAuthKey');
    Axios.post(`${API_CONFIG.HOST}/cable-store/create`, createStoreData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "X-USER-ID": userId
      }
    })
      .then(res => {
        var options = {
          place: 'tc',
          message: " " + "Registered Successfully",
          type: 'success',
          icon: 'far fa-check-circle',
          autoDismiss: 4
        };
        if (this.notification && this.notification.state.notifyTR.length < 1) {
          this.notification.notificationAlert(options);
        }
      })
      .catch(error => {
        const options = {
          place: 'tc',
          message: `  ${error.response ? error.response.data.message : 'Something went wrong'}`,
          type: 'danger',
          icon: 'fas fa-exclamation-triangle',
          autoDismiss: 4
        };
        if (this.notification && this.notification.state.notifyTR.length < 1) {
          this.notification.notificationAlert(options);
        }
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <div className="rna-container">
          <NotificationAlert ref={(c) => { this.notification = c }} />
        </div>
        <Card className={classes.card}>
          <CardBody>
            <Typography variant="h5" className={classes.formHeader}>
              Cable Registration (Kabel Registrierung)
            </Typography>
            <form onSubmit={this.submit}>
              <GridContainer spacing={1}>
                <GridItem xs={12} sm={6}>
                  <TextField
                    label="Prename (Vorname)"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.prename}
                    onChange={this.handleChange('prename')}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="Name (Nachname)"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.name}
                    onChange={this.handleChange('name')}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="Cable Id (Kabel-SN.)"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.deviceId}
                    onChange={this.handleChange('deviceId')}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="City (Stadt)"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.address}
                    onChange={this.handleChange('address')}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer spacing={3}>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="Mobile No. (Mobile Nr.)"
                    value={this.state.mobileNo}
                    onChange={this.handleChange('mobileNo')}
                    className={classes.textField}
                    margin="normal"
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="Vehicle Number (KFZ-Kennzeichen)"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.vehicleNumber}
                    onChange={this.handleChange('vehicleNumber')}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer spacing={3}>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="Email"
                    value={this.state.email}
                    onChange={this.handleChange('email')}
                    className={classes.textField}
                    margin="normal"
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="Password"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.password}
                    onChange={this.handleChange('password')}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer spacing={3}>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="Email (repeat/wiederholen)"
                    value={this.state.repeatEmail}
                    onChange={this.handleChange('repeatEmail')}
                    className={classes.textField}
                    margin="normal"
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <TextField
                    required
                    label="Password (repeat/wiederholen)"
                    className={classes.textField}
                    margin="normal"
                    value={this.state.repeatPassword}
                    onChange={this.handleChange('repeatPassword')}
                  />
                </GridItem>
              </GridContainer>
              <div className={classes.buttonContainer}>
                <Button
                  type="submit"
                  disabled={this.state.isButtonDisabled}
                  variant="contained"
                  className={classes.submitButton}
                >
                  Register (REGISTRIEREN)
                </Button>
              </div>
            </form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

CableStoreOnboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CableStoreOnboard);
